import React from "react";
import {
  Card,
  CardContent,
  Typography,
  Grid,
  TextField,
  Chip,
  Button,
  Box,
} from "@mui/material";
import { Search as SearchIcon, Clear as ClearIcon } from "@mui/icons-material";

const FiltersSection = ({
  showFilters,
  filterFields,
  filters,
  handleFilterChange,
  getActiveFiltersCount,
  handleResetFilters,
}) => {
  if (!showFilters) return null;

  return (
    <Card variant="outlined" sx={{ mt: 2 }}>
      <CardContent>
        <Typography
          variant="h6"
          sx={{ mb: 2, display: "flex", alignItems: "center", gap: 1 }}
        >
          <SearchIcon />
          Filters
          {getActiveFiltersCount() > 0 && (
            <Chip label={`${getActiveFiltersCount()} active`} size="small" color="primary" />
          )}
        </Typography>
        <Grid container spacing={2}>
          {filterFields.map((field) => (
            <Grid item xs={12} sm={6} md={4} key={field.name}>
              <TextField
                fullWidth
                label={field.label}
                name={field.name}
                value={filters[field.name]}
                onChange={handleFilterChange}
                size="small"
                variant="outlined"
                InputProps={{
                  startAdornment: field.icon,
                }}
              />
            </Grid>
          ))}
        </Grid>
        <Box sx={{ mt: 2, display: "flex", justifyContent: "flex-end" }}>
          <Button
            variant="outlined"
            startIcon={<ClearIcon />}
            onClick={handleResetFilters}
            disabled={getActiveFiltersCount() === 0}
          >
            Reset Filters
          </Button>
        </Box>
      </CardContent>
    </Card>
  );
};

export default FiltersSection;
